import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/interfaces/api-response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DirectoryService {

    private apiURL = environment.appApiUrl + "directory/";

    constructor(private http: HttpClient) { }

    getPatients(criteria: Array<string>): Observable<ApiResponse> {    
        return this.http.get<ApiResponse>(this.apiURL + "getPatient?" + (criteria.join('&')));
    }

    removePatient(patientID: string): Observable<ApiResponse> {
        return this.http.delete<ApiResponse>(this.apiURL + "remove/patient/" + patientID);
    }

    getPatient(patientID: string): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(this.apiURL + "patientInfos?patient=" + patientID);
    }

    addPatient(patientInfo: any) : Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.apiURL + "add/patient" , patientInfo);
    }
    
    updatePatient(patientInfo: any) : Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.apiURL + "update/patient" , patientInfo);
    }

    async loadPatient(info: any, filename: string): Promise<ApiResponse> {
        const body = {'info' : info, 'filename': filename};
        return this.http.post<ApiResponse>(this.apiURL + "loadpatient", body).toPromise();
    }
}
